import type { FC, PropsWithChildren } from 'react'
import styled from '@emotion/styled'

import { ChevronRightIcon } from '@segment/matcha/components/Icons/Common'
import ButtonText from '@segment/matcha/components/ButtonText'

import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'
import SectionBase, * as Section from '@segment/matcha/recipes/Section'

import LaunchIntegrationImage from './LaunchIntegrationImage'

const copy = {
  heading: `Launch your Segment integration`,
  description: `Go live in our Catalog to start onboarding customers and begin participating in co-marketing and sales opportunities.`,
}

const link = {
  text: `Start building`,
  url: `https://airtable.com/shrvZzQ6NTTwsc6rQ`,
}

const LaunchIntegration: FC<PropsWithChildren<unknown>> = () => {
  return (
    <StyledSectionBase variant="2Col" copyVariant="narrow" reverse={true}>
      <SectionCopy>
        <CopyTextBase>
          <CopyText.Heading variant="h2" tag="h3">
            {copy.heading}
          </CopyText.Heading>
          <CopyText.Description variant="pLarge">{copy.description}</CopyText.Description>
          <LinkWrapper size="medium" tag="a" href={link.url} iconEnd={ChevronRightIcon}>
            {link.text}
          </LinkWrapper>
        </CopyTextBase>
      </SectionCopy>

      <Section.Contents>
        <LaunchIntegrationImage />
      </Section.Contents>
    </StyledSectionBase>
  )
}

const StyledSectionBase = styled(SectionBase)`
  overflow: visible;
  ${Section.Wrapper} {
    ${({ theme }) => theme.breakpoints.up(`lg`)} {
      padding-top: 100px;
      padding-bottom: 100px;
    }
  }
`

const LinkWrapper = styled(ButtonText)`
  padding-top: 0;
`

const SectionCopy = styled(Section.Copy)`
  display: flex;
  align-items: center;
  align-self: center;
  direction: initial;
  justify-self: end;

  ${({ theme }) => theme.breakpoints.up(`lg`)} {
    max-width: 392px;
    justify-self: end;
  }
`

export default LaunchIntegration
